module.exports = __webpack_public_path__ + "media/react/assets/Description-c5d7373815e21a4b53d624b409408124.svg";